import API from "@/lib/API";

export const officeService = {
  /**
   * Fetches all office locations.
   */
  getLocations: async () => {
    const response = await API.get("/locations");
    return response.data || response;
  },

  /**
   * Creates a new office location.
   */
  createLocation: async (data) => {
    const response = await API.post("/locations", data);
    return response.data || response;
  },

  /**
   * Updates an existing office location.
   */
  updateLocation: async (id, data) => {
    const response = await API.put(`/locations/${id}`, data);
    return response.data || response;
  },

  /**
   * Deletes an office location.
   */
  deleteLocation: async (id) => {
    const response = await API.delete(`/locations/${id}`);
    return response.data || response;
  }
};

// Backward compatibility
export const getLocations = officeService.getLocations;
export const createLocation = officeService.createLocation;
export const updateLocation = officeService.updateLocation;
export const deleteLocation = officeService.deleteLocation;





